<script>
import { AuthHelpers } from '@paladin/core-auth'
import { PaladinCoreStateHelpers } from '@paladin/core'
export default {
  page() {
    return {
      title: this.metaData.user.firstName + ' ' + this.metaData.user.lastName,
      meta: [
        {
          name: 'description',
          content: `Edit profile for ${this.metaData.user.firstName} ${
            this.metaData.user.lastName
          }.`,
        },
      ],
    }
  },
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...AuthHelpers.authComputed,
    ...PaladinCoreStateHelpers.userComputed,
    metaData() {
      return {
        user: {
          firstName: this.user.profile
            ? this.user.profile.firstName
            : this.identity.profile.given_name,
          lastName: this.user.profile
            ? this.user.profile.lastName
            : this.identity.profile.family_name,
        },
      }
    },
  },
  mounted() {
    // console.log(this.user)
  },
  methods: {},
}
</script>

<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-6">
              <b-nav pills vertical>
                <b-nav-item :to="{ name: 'settings-profile' }">
                  Profile
                </b-nav-item>
                <b-nav-item
                  v-if="loggedIn && hasProfile"
                  :to="{ name: 'settings-account' }"
                >
                  Account
                </b-nav-item>
                <!-- <b-nav-item :to="">Another Link</b-nav-item>
                <b-nav-item disabled>Disabled</b-nav-item> -->
              </b-nav>
            </div>
            <div class="col-xl-6 col-lg-5 col-md-6">
              <!-- <transition
                name="fade"
                mode="out-in"> -->
              <RouterView :key="$route.fullPath" />
              <!-- </transition> -->
            </div>
            <div class="col-xl-4 col-lg-5 col-md-6">
              <b-card class="card-user">
                <div slot="image">
                  <img src="" alt="..." />
                </div>
                <div>
                  <div class="author">
                    <img
                      :src="identity.profile.picture"
                      class="avatar border-white"
                      alt="..."
                    />
                    <h4 class="title">
                      {{
                        user.profile
                          ? user.profile.firstName
                          : identity.profile.given_name
                      }}
                      {{
                        user.profile
                          ? user.profile.lastName
                          : identity.profile.family_name
                      }}
                      <br />
                      <!-- <a href="#">
                        <small>@{{ user.profile.firstName.toLowerCase() }}</small>
                      </a> -->
                    </h4>
                  </div>
                  <p class="description text-center">
                    "User bio..."
                  </p>
                  <p class="description text-center">
                    {{ user.accessToken }}
                  </p>
                </div>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
